module.exports = __webpack_public_path__ + "static/media/featured.a8e732c9.png";